// Shopify app handles differ between live and staging apps.
// Never guess: an incorrect fallback can send merchants to another app's billing.
const APP_HANDLE = (process.env.REACT_APP_SHOPIFY_APP_HANDLE || '').trim();

const getShop = (explicitShop = '') => {
  const params = new URLSearchParams(window.location.search);
  return (explicitShop || params.get('shop') || '').trim().toLowerCase();
};

export const getShopifyPricingUrl = (explicitShop = '') => {
  const shop = getShop(explicitShop);
  if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop)) return null;
  if (!/^[a-z0-9][a-z0-9-]*$/.test(APP_HANDLE)) return null;
  const storeHandle = shop.slice(0, -'.myshopify.com'.length);
  return `https://admin.shopify.com/store/${encodeURIComponent(storeHandle)}/charges/${encodeURIComponent(APP_HANDLE)}/pricing_plans`;
};

export const redirectToShopifyBilling = (shop) => {
  const targetUrl = getShopifyPricingUrl(shop);
  if (!targetUrl) {
    console.error('Shopify billing unavailable: verify the shop domain and REACT_APP_SHOPIFY_APP_HANDLE for this deployment.');
    return false;
  }
  try {
    window.open(targetUrl, '_top');
    return true;
  } catch (error) {
    console.error('Unable to open Shopify billing:', error);
    return false;
  }
};
